import { useQsFilters } from "@dash/filters";

import { CashRewardsAccountFilters, cashRewardsAccountFiltersSerializer } from "@megaron/megarax-uri";

export type AccountsFiltersType = CashRewardsAccountFilters;

export const useAccountsFilters = () => {
  const defaultFilters: AccountsFiltersType = {
    page: 0,
    excludeZeroBalance: false,
    sortByBalance: "desc",
  };

  const { filters, setFilters } = useQsFilters(cashRewardsAccountFiltersSerializer, defaultFilters);

  const setFilter =
    <K extends keyof AccountsFiltersType>(key: K) =>
    (value: AccountsFiltersType[K]) => {
      const newFilters = { ...filters };
      if (value === undefined) {
        delete newFilters[key];
      } else {
        newFilters[key] = value;
      }
      setFilters(newFilters);
    };

  return { filters, setFilter, setFilters, defaultFilters };
};
